export default __webpack_public_path__ + "static/media/bg1.2c3e3496.jpg";